import type { FaireProductEntity } from "../../entity_types/product";

export const p_1m5dcxhge7: FaireProductEntity = {
  token: "p_1m5dcxhge7",
  type: "product",
  name: "16 oz Elderberry Boost Syrup",
  brandToken: "b_6c40l41t0x",
  brandName: "Elderberry Boost",
  imageUrl:
    "https://cdn.faire.com/fastly/c6943924f073f093a1404b45113c7b19a127839b11377752c794b9c0b711ae24.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c1c493714d715c80c82f5fa32d2bf63557b3a3d76894cbb161560629c51ab3a0.png",
    "https://cdn.faire.com/fastly/a76c2c38eddd9a3e8ec700a8633ee06f57f37bc07f85442979fe3c7dc7e10acf.png",
  ],
  priceDollars: 14.49,
  description:
    "Elderberry Boost is our signature elderberry syrup, made in small batches with wild-harvested elderberries, seasonal raw honey, and a blend of warming spices.\n\nElderberries are naturally rich in anthocyanins — the compounds that give them their deep purple color and act as powerful antioxidants ✨. They also provide vitamin C and dietary fiber, supporting overall wellness and helping protect cells from oxidative stress.\n\nRaw honey contributes natural nutrients and polyphenols, while ginger, cinnamon, and clove bring aromatic flavor along with beneficial plant compounds and natural antioxidants. A touch of apple cider vinegar is included as a traditional ingredient, often valued for supporting balance as part of a healthy lifestyle.\n\nThe result is a delicious, well-rounded syrup — sweet, bold, and gently spiced — making it as enjoyable to taste as it is nourishing to include in your daily routine.\n\nIngredients: Organic elderberries, raw honey, ginger, cinnamon, clove, apple cider vinegar.\n\nSuggested Use: Enjoy by the spoonful, stir into teas 🍵, drizzle over yogurt or oatmeal, or mix into sparkling water for a refreshing beverage.",
  tags: [],
  msrpDollars: 24.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:25:49.440Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
